import { BellNotificationType } from 'notifications/enums';
import { TBellNotificationHandlers } from 'notifications/types';
import { registerNotificationHandlers } from 'notifications/utils/notification';

import { externalOrderUpdateNotificationHandler } from './externalOrderUpdate';

export const NOTIFICATION_HANDLERS: TBellNotificationHandlers = {
  [BellNotificationType.EXTERNAL_ORDER_UPDATE]: externalOrderUpdateNotificationHandler,
};

registerNotificationHandlers(NOTIFICATION_HANDLERS);
